import { ref } from 'vue'

import { UserAnalysisActionsEnum } from '@/api/userAnalysis'
import { randomUUID } from '@/views/pages/buyer-outlook/utils/randomUUID'
import { useAuth } from '../auth/src'
import { RouteLocationNormalized } from 'vue-router'

export class ActionFactory {
  private _sessionId = ref('')

  get sessionId() {
    return this._sessionId.value
  }

  set sessionId(value: string) {
    this._sessionId.value = value
  }

  get baseAction() {
    const { auth } = useAuth()
    const email = auth.email || ''
    const companyName = auth.companyName || ''
    const mockToken = auth.mockToken || ''

    return {
      email,
      anonymous: email ? '' : mockToken || `anonymous-${randomUUID()}@air8.io`,
      ...(auth.companyId ? { company_id: Number(auth.companyId) } : {}),
      company_name: companyName,
      session_id: Number(this._sessionId.value),
      page_url: window.location.href
    }
  }

  public userAction = ({ actionType, actionDetails }: { actionType: UserAnalysisActionsEnum; actionDetails: any }) => {
    return {
      ...this.baseAction,
      action_type: actionType,
      action_details: actionDetails
    }
  }

  public visitAction = ({ details, navigateFrom }: { details: any; navigateFrom?: RouteLocationNormalized }) => {
    let _navigateFrom = {}
    if (navigateFrom?.path) {
      const { origin } = window.location
      _navigateFrom = { page_url: `${origin}${navigateFrom?.path}` }
    }

    return {
      ...this.baseAction,
      ..._navigateFrom, // replace with the previous page url if user navigate to another page
      action_type: UserAnalysisActionsEnum.PAGE_VISIT,
      action_details: details
    }
  }
}
